'use strict';

import adminRoutes from './admin';
import contentApi from './content-api';

export default {
  admin: adminRoutes,
  'content-api': contentApi,
};
